var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(e.target.tagName !== 'A' && this.hasAttribute('data-href')) {
			var href = this.dataset.href;

			if(href.indexOf(location.host) == -1)
				window.open(href);
			else
				window.location.href = href;
		}
	});
});